import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import styles from './DateSwitcher.module.css';
import addWeekDays from '../../../Lib/Utils/Date/add-week-days';
import Button from '../Button/Button';

const isPastDate = (limit, date, delta) => {
  if (!limit) return false;

  const nextDate = moment.utc(date).add(delta, 'days');

  return delta < 0
    ? nextDate.isBefore(moment.utc(limit))
    : nextDate.isAfter(moment.utc(limit));
};

class DateSwitcher extends Component {
  constructor(props) {
    super(props);

    this.state = {
      date: props.start || props.date,
    };

    this.goToToday = this.goToToday.bind(this);
    this.updateDate = this.updateDate.bind(this);
  }

  componentDidUpdate({ date: prevDate }) {
    const { date } = this.props;

    if (!moment(prevDate).isSame(moment(date))) {
      this.setState({ date });
    }
  }

  updateDate(numDays) {
    const { business, onDateChange } = this.props;
    const { date: d } = this.state;
    const date = business
      ? addWeekDays(d, numDays)
      : moment.utc(d).add(numDays, 'days');

    this.setState({ date }, () => onDateChange(date));
  }

  goToToday() {
    const { onDateChange } = this.props;
    const today = moment().startOf('day');
    this.setState({ date: today }, () => onDateChange(today));
  }

  render() {
    const { start, end, hideToday } = this.props;
    const { date } = this.state;

    return (
      <div className={styles.container} data-testid="date-switcher-container">
        <div className={styles.date}>
          {moment.utc(date).format('MMMM Do YYYY')}
        </div>

        <div className={styles.arrows}>
          <div className={styles.paginationBackArrows}>
            <IconButton
              disabled={isPastDate(start, date, -7)}
              onClick={() => this.updateDate(-7)}
              aria-label="Last Week"
              size="large"
            >
              <FirstPageIcon />
            </IconButton>
            <IconButton
              disabled={isPastDate(start, date, -1)}
              onClick={() => this.updateDate(-1)}
              aria-label="One Day Back"
              size="large"
            >
              <KeyboardArrowLeft />
            </IconButton>
          </div>
          {!hideToday && (
            <Button
              small
              color="white"
              variant="contained"
              onClick={this.goToToday}
              className={styles.dateButton}
            >
              Today
            </Button>
          )}
          <div className={styles.paginationNextArrows}>
            <IconButton
              disabled={isPastDate(end, date, 1)}
              onClick={() => this.updateDate(1)}
              aria-label="One Day Forward"
              size="large"
            >
              <KeyboardArrowRight />
            </IconButton>
            <IconButton
              disabled={isPastDate(end, date, 7)}
              onClick={() => this.updateDate(7)}
              aria-label="Next Week"
              size="large"
            >
              <LastPageIcon />
            </IconButton>
          </div>
        </div>
      </div>
    );
  }
}

DateSwitcher.propTypes = {
  business: PropTypes.bool,
  date: PropTypes.instanceOf(moment).isRequired,
  end: PropTypes.instanceOf(moment),
  hideToday: PropTypes.bool,
  onDateChange: PropTypes.func.isRequired,
  start: PropTypes.instanceOf(moment),
};

DateSwitcher.defaultProps = {
  business: false,
  end: null,
  hideToday: false,
  start: null,
};

export default DateSwitcher;
